import { useGet } from '../../HttpClient';
import { tenantHierarchyBaseUrl } from '../BaseUrls';
import { useQueryWithErrorHandling } from '../../../hooks/UseQueryWithErrorHandling';

const pillarCode = "tms";
 
export function useConfigRule({ ouId }: { ouId: string }) {
  const get = useGet(true, pillarCode);
  const getRules = async (ouId: string) => get<any[]>(`${tenantHierarchyBaseUrl}/organisation-units/${ouId}/rules`);
  return useQueryWithErrorHandling({
    queryKey: ['config-rule', ouId],
    queryFn: async () => await getRules(ouId),
    enabled: !!ouId,
    refetchOnMount: false,
  });
}
